import { ReqBodyType } from './types/reqBody';
import HttpClient from './utils/HttpClient';

interface IConsultsService {
  codUsu?: number;
  perfilUsu?: number;
  token: string;
  consultCode?: number;
  reqBody?: ReqBodyType;
  codEmpresa?: number;
  sentido?: number;
  trajeto?: number;
  rota?: number;
  mes?: number;
  ano?: number;
  cpf?: string;
  tipoPesquisa?: number;
  tipoRot?: number;
  valorLong?: number;
  valorInt?: number;
  valorInt1?: number;
  valorString?: string;
  valorString1?: string;
  processo?: number;
  data1?: string;
  data2?: string;
  tipoRel?: number;
  sequenciaTrajeto?: number;
  valorInt2?: number;
  tipoSel?: number;
  data?: string;
  tipoSelecao?: string;
  codConsulta?: string;
  codArq?: string;
  tipoArq?: string;
  tipoAcao?: number;
  nomeArquivo?: string;
}

class ConsultsService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_PATHNAME ?? '');
  }

  getConsultResult = async ({ token, codUsu, perfilUsu, codEmpresa, consultCode }: IConsultsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_Roteirizar?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&codConsulta=${consultCode}&cpf=0`,
    });
  };

  getMrConsultResult = async ({ token, codUsu, perfilUsu, codEmpresa, consultCode }: IConsultsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_RoteirizarMR?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&codConsulta=${consultCode}&cpf=0&tipoAcao=1`,
    });
  };

  changeConsultOption = async ({ token, reqBody }: IConsultsService) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_Roteirizar_Ret',
      reqBody
    });
  };

  changeConsultOptionMr = async ({ token, reqBody }: IConsultsService) => {
    return this.httpClient.put({
      token,
      path: '/api/SMob_RoteirizarMRAcao',
      reqBody
    });
  };

  getRouteOfOption = async ({ token, codUsu, perfilUsu, codEmpresa, consultCode, sentido, trajeto, rota }: IConsultsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_Roteirizar_Ret?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&tipoPesq=1&codConsulta=${consultCode}&sentido=${sentido}&trajeto=${trajeto}&rota=${rota}`
    });
  };

  getRouteOfOptionMr = async ({ token, codUsu, perfilUsu, consultCode, trajeto, sequenciaTrajeto, codEmpresa }: IConsultsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_RoteirizarMRAcao?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codConsulta=${consultCode}&tipoAcao=2&trajeto=${trajeto}&sequenciaTrajeto=${sequenciaTrajeto}&codEmpresa=${codEmpresa}`
    });
  };

  sendForRouting = async ({ token, reqBody }: IConsultsService) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_Roteirizar',
      reqBody
    });
  };

  sendForMultiRouting = async ({ token, reqBody }: IConsultsService) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_RoteirizarMR',
      reqBody
    });
  };

  getDataToMakeManualRouting = async ({ token, codUsu, perfilUsu, codEmpresa, consultCode }: IConsultsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_RotManual?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&codConsulta=${consultCode}`
    });
  };

  createInstruction = async ({ token, reqBody}: IConsultsService) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_RotManual',
      reqBody,
    });
  };

  removeOrEditInstruction = async ({ token, reqBody}: IConsultsService) => {
    return this.httpClient.put({
      token,
      path: '/api/SMob_RotManual',
      reqBody,
    });
  };

  copyResultToManualRouting = async ({ token, reqBody }: IConsultsService) => {
    return this.httpClient.post({
      path: '/api/SMob_RotManual_Envio',
      token,
      reqBody,
    });
  };

  generateManualRouting = async ({ token, reqBody }: IConsultsService) => {
    return this.httpClient.put({
      path: '/api/SMob_RotManual_Envio',
      token,
      reqBody,
    });
  };

  changeConsultImplantation = async ({ token, reqBody }: IConsultsService) => {
    return this.httpClient.post({
      path: '/api/SMobAceiteRot',
      token,
      reqBody,
    });
  };

  sendMyLinkEmail = async ({ token, reqBody }: IConsultsService) => {
    return this.httpClient.put({
      path: '/api/SMobAceiteRot',
      token,
      reqBody,
    });
  };

  getPreAdmDashboardData = async ({ token, codUsu, perfilUsu, codEmpresa, mes, ano }: IConsultsService) => {
    return this.httpClient.get({
      path: `/api/SMob_Roteirizar_Geral?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&mes=${mes}&ano=${ano}`,
      token,
    });
  };

  getPreAdmDashboardImpAutData = async ({ token, codUsu, perfilUsu, codEmpresa, mes, ano }: IConsultsService) => {
    return this.httpClient.get({
      path: `/api/SMob_NotificaImplantar2?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&mes=${mes}&ano=${ano}&tipoDados=2`,
      token,
    });
  };

  getBaseDashboardImpAutData = async ({ token, codUsu, perfilUsu, codEmpresa, mes, ano }: IConsultsService) => {
    return this.httpClient.get({
      path: `/api/SMob_NotificaImplantar2?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&mes=${mes}&ano=${ano}&tipoDados=3`,
      token,
    });
  };

  getOtimizationReport = async ({ token, codUsu, perfilUsu, codEmpresa, data1, data2 }: IConsultsService) => {
    return this.httpClient.get({
      path: `/api/SMob_Rels?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&data1=${encodeURIComponent(data1 ?? 0)}&data2=${encodeURIComponent(data2 ?? 0)}&tipoRel=50&valorInt=0&valorInt1=0&valorInt2=0&valorLong=0&valorLong1=0&valorLong2=0&valorString=0&valorString1=0&valorString2=0`,
      token,
    });
  };

  getOtimizationBaseReport = async ({ token, codUsu, perfilUsu, codEmpresa, data1, data2 }: IConsultsService) => {
    return this.httpClient.get({
      path: `/api/SMob_Rels?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&data1=${encodeURIComponent(data1 ?? 0)}&data2=${encodeURIComponent(data2 ?? 0)}&tipoRel=5&valorInt=0&valorInt1=0&valorInt2=0&valorLong=0&valorLong1=0&valorLong2=0&valorString=0&valorString1=0&valorString2=0`,
      token,
    });
  };

  getListOfFilesByPeriod = async ({ token, codUsu, perfilUsu, codEmpresa, data1, data2 }: IConsultsService) => {
    return this.httpClient.get({
      path: `/api/SMob_Lista?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa || 0}&data1=${encodeURIComponent(data1 ?? 0)}&data2=${encodeURIComponent(data2 ?? 0)}&valorInt=0&valorInt1=0&valorLong=0&valorLong1=0&valorString=0&valorString1=0&tipoLista=1`,
      token,
    });
  };

  getOmieInstallmentsReport = async ({ token, codUsu, perfilUsu, data1, data2 }: IConsultsService) => {
    return this.httpClient.get({
      path: `/api/SMob_Rels?codUsu=${codUsu ?? 0}&perfilUsu=${perfilUsu ?? 0}&codEmpresa=0&data1=${encodeURIComponent(data1 ?? 0)}&data2=${encodeURIComponent(data2 ?? 0)}&tipoRel=705&valorInt=0&valorInt1=0&valorInt2=0&valorLong=0&valorLong1=0&valorLong2=0&valorString=&valorString1=&valorString2=`,
      token,
    });
  };

  getGeneralReports = async ({ token, codUsu, perfilUsu, codEmpresa, data1, data2, tipoRel, valorInt1, valorLong, valorInt, valorInt2 }: IConsultsService) => {
    return this.httpClient.get({
      path: `/api/SMob_Rels?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa ?? 0}&data1=${encodeURIComponent(data1 ?? 0)}&data2=${encodeURIComponent(data2 ?? 0)}&tipoRel=${tipoRel}&valorInt=${valorInt ?? 0}&valorInt1=${valorInt1 ?? 0}&valorInt2=${valorInt2 ?? 0}&valorLong=${valorLong ?? 0}&valorLong1=0&valorLong2=0&valorString=0&valorString1=0&valorString2=0`,
      token,
    });
  };

  getBaseDashboardData = async ({ token, codUsu, perfilUsu, codEmpresa, mes, ano }: IConsultsService) => {
    return this.httpClient.get({
      path: `/api/SMob_RotPesqBase?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&mes=${mes}&ano=${ano}`,
      token,
    });
  };

  finishBaseProcess = async ({ token, reqBody }: IConsultsService) => {
    return this.httpClient.post({
      path: '/api/SMob_RotPesqBase',
      token,
      reqBody,
    });
  };

  getDataToCreateConsult = async ({ token, codUsu, perfilUsu, codEmpresa, cpf }: IConsultsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_Roteirizar?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&codConsulta=0&cpf=${cpf ? encodeURIComponent(cpf) : 0}`,
    });
  };

  searchConsults = async ({ token, codUsu, perfilUsu, codEmpresa, tipoPesquisa, tipoRot, valorLong, valorInt, valorInt1, valorString, processo, data1, data2 }: IConsultsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_RoteirizarPesq?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&tipoPesquisa=${tipoPesquisa}&tipoRot=${tipoRot}&valorLong=${valorLong}&valorInt=${valorInt}&valorInt1=${valorInt1}&valorString=${valorString}&processo=${processo}&data1=${data1 ?? 0}&data2=${data2 ?? 0}`,
    });
  };

  loadListsForSearchingConsults = async ({ token, codUsu, perfilUsu, codEmpresa, mes, ano }: IConsultsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_Roteirizar_Geral?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&mes=${mes}&ano=${ano}`,
    });
  };

  downloadManyDocuments = async ({ token, reqBody }: IConsultsService) => {
    return this.httpClient.put({
      token,
      path: '/api/SMob_Roteirizar_Ret',
      reqBody,
    });
  };

  auditSearches = async ({ token, codUsu, perfilUsu, codEmpresa, tipoPesquisa, valorInt, valorInt1, valorLong, valorString, valorString1 }: IConsultsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_AuditoriaGeral?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa ?? 0}&tipoPesquisa=${tipoPesquisa}&valorInt=${valorInt ?? 0}&valorInt1=${valorInt1 ?? 0}&valorLong=${valorLong ?? 0}&valorString=${valorString ?? 0}&valorString1=${valorString1 ?? 0}`,
    });
  };

  searchCompaniesWithConsultsAtPeriod = async ({ token, codUsu, perfilUsu, mes, ano }: IConsultsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_AuditoriaPrincipal?codUsu=${codUsu}&perfilUsu=${perfilUsu}&mes=${mes ?? 0}&ano=${ano}`,
    });
  };

  removeFilesOrSendForRouting = async ({ token, reqBody }: IConsultsService) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_AuditoriaProc',
      reqBody,
    });
  };

  sendEmailsForAllUsersFromFile = async ({ token, reqBody }: IConsultsService) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_NotAuto',
      reqBody,
    });
  };

  getPartnersList = async ({ token, codUsu, perfilUsu, codEmpresa, tipoSel, valorLong, valorInt, valorString, data1, data }: IConsultsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMobListasSelecao?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa || 0}&tipoSel=${tipoSel ?? 2}&valorLong=${valorLong ?? 0}&valorInt=${valorInt ?? 0}&valorString=${valorString ?? 0}&data1=${data1 ?? new Date().toISOString()}&data=${data ?? new Date().toISOString()}`,
    });
  };

  getMapDataViewData = async ({ token, codUsu, perfilUsu, codEmpresa, tipoSelecao, codConsulta, codArq, tipoArq }: IConsultsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_MapaTendencia?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa || 0}&tipoSelecao=${tipoSelecao ?? 2}&codConsulta=${codConsulta ?? 0}&codArq=${codArq ?? 0}&tipoArq=${tipoArq ?? 0}`,
    });
  };

  importVtRegistrationData = async ({ token, reqBody }: IConsultsService) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_ListasGerais',
      reqBody,
    });
  };

  getVtRegistrationFilesList = async ({ token, codUsu, perfilUsu, codEmpresa, tipoAcao }: IConsultsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_ListasGerais?tipoAcao=${tipoAcao}&codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}`,
    });
  };

  getVtRegistrationConfig = async ({ token, codUsu, perfilUsu, codEmpresa, codArq }: IConsultsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_NotificaCadVT?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&codArq=${codArq}`,
    });
  };

  saveVtRegistrationConfig = async ({ token, reqBody }: IConsultsService) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_NotificaCadVT',
      reqBody,
    });
  };
}

export default new ConsultsService();
